
import AdsApi from '../../libs/ads-request/ads-api';
import { groupByDate } from '../../libs/helpers';

export default {
  name: 'NotificationsView',
  data: () => ({
    navigation: [{ text: 'Home', boxIcon: 'home', navigate: 'home' }, { text: 'Notificaciones' }],
    total: 5,
    notifications: [],
  }),
  mounted() {
    this.getNotifications();
  },
  methods: {
    getNotifications() {
      this.loaderShow('Obteniendo notificaciones');

      AdsApi.getNotifications()
        .then((response) => {
          const { data } = response;

          this.notifications = groupByDate(data.notifications);
        })
        .catch((err) => this.alertShow(err, 'error'))
        .then(this.loaderHide);
    },
  },
};
